import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src="/imagenes/logo_servibalanzas.webp" height="124" width="186" alt="Servibalanzas" />
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li>
                <Link 
                  to="/" 
                  className={location.pathname === '/' ? 'active' : ''}
                  onClick={closeMenu}
                >
                  Inicio
                </Link>
              </li>
              
              {/* Servicios Dropdown */}
              <li
                className="nav-item-dropdown"
                onMouseEnter={() => setActiveDropdown('servicios')}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <Link
                  to="/servicios"
                  className={`nav-link ${location.pathname === '/servicios' ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Servicios
                  <span className="dropdown-arrow">▼</span>
                </Link>
                <ul className={`dropdown-menu ${activeDropdown === 'servicios' ? 'show' : ''}`}>
                  <li><Link to="/servicios#servicio-tecnico" onClick={closeMenu}>Servicio Técnico</Link></li>
                  <li><Link to="/servicios#obras-civiles" onClick={closeMenu}>Obras Civiles</Link></li>
                  <li><Link to="/servicios#desarrollo" onClick={closeMenu}>Desarrollo</Link></li>
                </ul>
              </li>

              {/* Productos Dropdown */}
              <li
                className="nav-item-dropdown"
                onMouseEnter={() => setActiveDropdown('productos')}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <Link
                  to="/productos"
                  className={`nav-link ${location.pathname === '/productos' ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Productos
                  <span className="dropdown-arrow">▼</span>
                </Link>
                <ul className={`dropdown-menu ${activeDropdown === 'productos' ? 'show' : ''}`}>
                  <li><Link to="/productos/balanzas" onClick={closeMenu}>Balanzas</Link></li>
                  <li><Link to="/productos/plataformas" onClick={closeMenu}>Plataformas</Link></li>
                  <li><Link to="/productos/basculas-camiones" onClick={closeMenu}>Básculas de Camiones</Link></li>
                  <li><Link to="/productos/sistemas-pesaje" onClick={closeMenu}>Pesaje Dinámico</Link></li>
                  <li><Link to="/productos/accesorios" onClick={closeMenu}>Etiquetado</Link></li>
                  <li><Link to="/productos/indicadores" onClick={closeMenu}>Indicadores</Link></li>
                  <li><Link to="/productos/basculas-de-colgar" onClick={closeMenu}>Básculas para Colgar</Link></li>
                  <li><Link to="/productos/masas-patrones" onClick={closeMenu}>Masas Patrones</Link></li>
                  <li><Link to="/productos/celdas-de-cargas" onClick={closeMenu}>Celdas de Cargas</Link></li>
                  <li><Link to="/productos/balanzas-de-pedestal-packing" onClick={closeMenu}>Balanzas de Pedestal (Packing)</Link></li>
                </ul>
              </li>

              {/* Contacto Dropdown */}
              <li
                className="nav-item-dropdown"
                onMouseEnter={() => setActiveDropdown('contacto')}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <Link
                  to="/contacto"
                  className={`nav-link ${location.pathname === '/contacto' ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Contacto
                  <span className="dropdown-arrow">▼</span>
                </Link>
                <ul className={`dropdown-menu ${activeDropdown === 'contacto' ? 'show' : ''}`}>
                  <li><Link to="/contacto#ubicacion" onClick={closeMenu}>Ubicación</Link></li>
                  <li><Link to="/contacto#formulario" onClick={closeMenu}>Formulario de Contacto</Link></li>
                </ul>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            <a 
                              href="https://wa.me/+56976234326?text=Hola,%20me%20interesa%20conocer%20más%20sobre%20sus%20servicios%20de%20pesaje%20industrial" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-secondary whatsapp-btn"
            >
              WhatsApp
            </a>
          </div>

          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 